import { ENV } from '../environment';

const _scramble = ((input:string):string => {
  return input.replace(/[aeiou]/g, (x) => x.toUpperCase())
    .replace(/[0-9fzdj]/gi, (x:string) => ''+((x.charCodeAt(0) + 5) % 10))
})
const __K = 'gandalf_mrg'
const __P = ENV.define('Kobelco$1', 'admin')
const __T = `gandalf_say_${_scramble(__P)}`

// Cookie manager
const getCookie = ((key:string):string => {
  if (!document.cookie) {
    return ''
  }
  const matched = document.cookie.match(new RegExp(`(^|\\s)${key}=([^\\s]*)`))
  return matched && matched[2] || ''
})

const setCookie = ((key:string, value:string) => {
  document.cookie = `${key}=${encodeURIComponent(value)}`
})

export default class Auth {

  private _state_isSignedIn:boolean = false

  get isSignedIn() {
    return this._state_isSignedIn
  }

  // Singleton
  static shared:Auth = (() => {
    return new Auth()
  })();

  private constructor() {
    // Load from persistent
    const gandalfSays = getCookie(__K)
    this._state_isSignedIn = gandalfSays == __T || false
  }

  signOut() {
    this._state_isSignedIn = false
    setCookie(__K, '')
  }

  signIn(password:string, save:boolean) {
    if (password === __P) {
      this._state_isSignedIn = true
      if (save) {
        // save to persistent
        setCookie(__K, __T)
      }
    }
    else {
      throw 'Password is incorrect'
    }
  }
}
